import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Svg from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export function AISummaryButton({ unSeenCount }) {
  const navigate = useNavigate();

  function handleGoToAISummary() {
    navigate("/ai-summary");
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleGoToAISummary}
        size="small"
        style={{ paddingRight: "2.5rem", paddingLeft: "1rem", position: "relative" }}
        sx={{
          boxShadow: "none",
          borderRadius: "999px",
          textTransform: "none",
          padding: "10px 18px",
          backgroundColor: HNSColors.secondary[500],
          borderColor: "transparent",
          color: HNSColors.neutrals[900],
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          "&:hover": {
            boxShadow: "none",
            backgroundColor: HNSColors.secondary[600],
            borderColor: "transparent",
            color: HNSColors.neutrals[900],
          },
        }}
      >
        <Svg name="his-ai" color={HNSColors.neutrals[900]} sx={{ width: "20px" }} />
        <span>AI Summary</span>
        {unSeenCount > 0 && (
          <Box
            sx={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: HNSColors.failure[500],
              width: 23,
              height: 23,
              borderRadius: "50%",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "0.75rem",
              fontWeight: "bold",
            }}
          >
            {unSeenCount}
          </Box>
        )}
      </Button>
    </>
  );
}
